// @flow
import * as React from "react"
import type { Image } from "data/images/types"
import { ImageSwitchNumericWrap } from "./styled"

type Props = {|
  images: Image[],
  activeIndex: number,
|}

const ImageSwitchNumeric = ({ images, activeIndex }: Props) => (
  <ImageSwitchNumericWrap>{`${activeIndex + 1} / ${
    images.length
  }`}</ImageSwitchNumericWrap>
)

export default ImageSwitchNumeric



// WEBPACK FOOTER //
// ./src/components/ImageSwitch/Numeric/index.js